import React, { forwardRef, useMemo } from "react";
import { FieldTypes } from "utils/formUtils";
import { urlRegexValidator } from "utils/formUtils";
import GenericPullCredentialsForm from "../GenericPullCredentialsForm";
import AppcheckMappingForm from "./AppcheckMappingForm";

function AppcheckCredentialsForm(props, ref) {
  const fields = useMemo(() => {
    return [
      {
        name: "apiEndpoint",
        label: "API Endpoint",
        required: true,
        rules: [urlRegexValidator],
      },
      {
        name: "apiKey",
        label: "API Key",
        required: true,
        type: FieldTypes.PASSWORD,
      },
    ];
  }, []);

  return (
    <GenericPullCredentialsForm
      {...props}
      ref={ref}
      fields={fields}
      MappingForm={AppcheckMappingForm}
      initialValue={{ apiEndpoint: "https://api.appcheck-ng.com" }}
    />
  );
}

export default forwardRef(AppcheckCredentialsForm);
